import { Component, input, OnInit } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { AlertComponent } from '@pedix-workspace/angular-ui-alert';
import { FormValidationComponent } from '@pedix-workspace/angular-ui-form-reactive';

@Component({
  selector: 'pxw-shipping-not-allowed',
  templateUrl: './shipping-not-allowed.component.html',
  styleUrls: ['./shipping-not-allowed.component.scss'],
  imports: [AlertComponent, FormValidationComponent, FormsModule],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class ShippingNotAllowedComponent {
  readonly isFormSubmitted = input.required<boolean>();
  readonly message = input.required<string>();
}
